<template>
<div class="SceneListContainer">
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <el-input placeholder="请输入联动名称" v-model="queryForm.key"></el-input>
      <button class="primaryBtn" @click="search">搜索</button>
      <button class="primaryBtn" @click="handleAddClick('add')">新增联动</button>
      <button class="primaryBtn" @click="handleAddClickScene('add')">新增场景</button>
      <!-- <div class="query-right">
      </div> -->
    </div>
    <!-- 联动 场景列表 -->
    <div class="tableBox contentShowArea">
      <border-table :loading="DatasLoading" :tableData="DataList"  :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleDataCurrentChange" @sizeChange="handleDataSizeChange">
        <el-table-column prop="sceneName" label="名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
        <el-table-column prop="isEnabled" label="状态">
          <template #default="{row}">
            <span
              class="is-delete"
              :style="{ color: row.isEnabled ? '#13CE66' : '#FF4949'}">
              {{row.isEnabled ? '启用' : '禁用'}}
            </span>
            <el-switch
              v-model="row.isEnabled"
              @change="handleSwithChange($event, row.id)"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="isEnabled" label="类型">
          <template #default="{row}">
            <span>{{row.linkageMode == 0 ? '联动' : '场景'}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="240">
          <template #default="{row}">
            <el-button class="editBtn" type="text" @click="handleAddClick('view', row)" >查看</el-button> 
            <el-button :style="{color:row.isEnabled ? '#28C6A2':'#ccc'}" class="editBtn" type="text" icon="el-icon-edit-outline" @click="handleAddClick('edit', row)" :disabled="!row.isEnabled">编辑</el-button> 
            <el-button :style="{color:row.isDelete ? '#ccc':'#DD3071'}" class="delBtn" type="text" icon="el-icon-delete" :disabled="row.isDelete" @click="handleDeleteClick(row)" :loading="isDeleting">删除</el-button>
            <!-- <el-button class="editBtn" type="text" @click="handleGoClick(row.id)" >{{row.linkageMode == 0 ? '联动记录' : '场景记录'}}</el-button> -->
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>
  <!-- 联动表单 -->
  <el-drawer :title="dataDrawer.title" size="800px" :modal="false" :visible.sync="dataDrawer.show" @close="handleDrawerClose" :wrapperClosable="false" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form class="formBox" ref="dataDrawerForm" :model="dataDrawer.form" :rules="dataDrawer.formRules" label-position="right">
          <p class="drawer-title">基本信息</p>
          <el-form-item label="联动名称" prop="sceneName" class="name-form">
            <el-input v-model.trim="dataDrawer.form.sceneName" type="text" :maxlength="30" placeholder="请输入联动名称" :disabled="!isShow" class="input-name"></el-input>
          </el-form-item>
          <p class="drawer-title">触发器</p>
          <div v-for="(triggerItem, index) in dataDrawer.form.trigger" :key="index">
            <el-form-item :error="isError(triggerItem.deviceType, '设备类型不能为空')">
              <el-select v-model="triggerItem.deviceType" placeholder="请选择" :disabled="!isShow" @change="handleChangeDeviceType($event, index)">
                <el-option
                  v-for="item in deviceTypeOptions"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(triggerItem.imei, '设备imei不能为空')">
              <!-- @blur="handleBlurImei($event, index)" -->
              <el-select
                :disabled="!isShow"
                v-model="triggerItem.imei"
                filterable
                remote
                @change="handleChangeImei($event, index)"
                @focus="handleFocusImei(index, 'triggerImeiFocusIndex')"
                placeholder="请输入/选择imei"
                :remote-method="imeiMethod"
                :loading="imeiLoading">
                <el-option
                  v-for="item in TImeiOptions(index)"
                  :key="item.imei"
                  :label="item.imei"
                  :value="item.imei">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(triggerItem.type, '触发方式不能为空')">
              <el-select v-model="triggerItem.type" placeholder="请选择触发方式" :disabled="!isShow" @change="handleChangeTrigger($event, index)">
                <el-option
                  v-for="(item, i) in triggerOption"
                  :key="i"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(triggerItem.modelType, '触发属性不能为空')">
              <el-select v-model="triggerItem.modelType" placeholder="请选择触发属性" :disabled="!isShow" @change="handleChangeattr($event, index)" @visible-change="handleVisible($event, index)">
                <el-option
                  v-for="(item, i) in TTypeOptions(index)"
                  :key="i"
                  :label="item.fieldVar"
                  :value="item.fieldName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(triggerItem.compareType, '比较模式不能为空')">
              <el-select v-model="triggerItem.compareType" placeholder="请选择比较模式" :disabled="!isShow" @change="handleChangecomparer">
                <el-option
                  v-for="(item, i) in comparerOption"
                  :key="i"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(triggerItem.compareValue, '比较值不能为空')">
              <el-select v-if="isBoolean(index)" :disabled="!isShow" v-model="triggerItem.compareValue" placeholder="请输入比较值">
                <el-option label="报警" value="1" />
                <!-- <el-option label="不报警" value="false" /> -->
              </el-select>
              <el-input v-else v-model.trim="triggerItem.compareValue" type="text" :maxlength="30" placeholder="请输入比较值" :disabled="!isShow"></el-input>
              <!-- <p slot="error" class="el-form-item__error">比较值不能为空</p> -->
            </el-form-item>
          </div>
          <p class="drawer-title">执行器</p>
          <div v-for="(actionItem, index) in dataDrawer.form.action" :key="`action${index}`">
            <el-form-item :error="isError(actionItem.type, '执行动作不能为空')">
              <el-select v-model="actionItem.type" placeholder="请选择执行动作" :disabled="!isShow" @change="handleChangeactionType($event, index)">
                <el-option
                  v-for="(item, i) in ExecuteActionOption"
                  :key="i"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(actionItem.deviceType, '设备类型不能为空')">
              <el-select v-model="actionItem.deviceType" placeholder="请选择" :disabled="!isShow" @change="handleChangeDeviceType1($event, index)">
                <el-option
                  v-for="item in deviceTypeOptions"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(actionItem.imei, 'imei不能为空')">
              <el-select
                :disabled="!isShow"
                v-model="actionItem.imei"
                filterable
                remote
                reserve-keyword
                @change="handleChangeImei1($event, index)"
                @focus="handleFocusImei(index, 'actionImeiFocusIndex')"
                placeholder="请输入/选择imei"
                :remote-method="imeiMethod1"
                :loading="imeiLoading1">
                <el-option
                  v-for="item in AImeiOptions(index)"
                  :key="item.imei"
                  :label="item.imei"
                  :value="item.imei">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(actionItem.modelType, '触发属性不能为空')" v-if="actionItem.type == '1'">
              <el-select v-model="actionItem.modelType" placeholder="请选择触发属性" :disabled="!isShow" @change="handleChangeattr1($event, index)">
                <el-option
                  v-for="(item, i) in ATypeOptions(index)"
                  :key="i"
                  :label="item.fieldVar"
                  :value="item.fieldName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(actionItem.compareValue, '比较值不能为空')" v-if="actionItem.type == '1'">
              <!-- <el-input v-if="!isBoolean1(index)" v-model.trim="actionItem.compareValue" type="text" :maxlength="30" placeholder="请输入比较值" :disabled="!isShow"></el-input> v-else -->
              <el-select v-model="actionItem.compareValue" placeholder="请输入比较值" :disabled="!isShow">
                <el-option label="开" value="1" />
                <el-option label="关" value="0" />
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drawerFoot" v-if="isShow">
        <el-button type="primary" @click="handleAddSave" :loading="dataDrawer.saving">{{ dataDrawer.saving ? '提交中' : '提交' }}</el-button>
        <el-button @click="dataDrawer.show = false">取 消</el-button>
      </div>
    </div>
  </el-drawer>
  <!-- 场景表单 -->
  <el-drawer :title="sceneTitle" size="860px" :modal="false" :visible.sync="sceneShow" @close="handleDrawerCloseScene" :wrapperClosable="false" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form class="formBox" ref="dataDrawerScene" :model="sceneForm" :rules="sceneFormRules" label-position="right">
          <p class="drawer-title">基本信息</p>
          <el-form-item label="场景名称" prop="sceneName" class="name-form">
            <el-input v-model.trim="sceneForm.sceneName" type="text" :maxlength="30" placeholder="请输入联动名称" :disabled="!isShowScene" class="input-name"></el-input>
          </el-form-item>
          <p class="drawer-title">触发器</p>
          <div v-for="(triggerItem, index) in sceneForm.trigger" :key="index">
            <el-form-item :error="isError(triggerItem.region, '设备区域不能为空')">
              <!-- <el-cascader
                v-model="triggerItem.region"
                :options="deviceRegionScene"
                :show-all-levels="false"
                :disabled="!isShowScene"
                placeholder="请选择设备区域"
                :props="propsScene"
              ></el-cascader> -->
              <!-- :normalizer="normalizer" -->
              <treeselect
                :flat='true'
                :multiple="false"
                :options="regionOptions"
                :load-options="loadOptions"
                @select="treeEven($event, index)"
                :disabled="!isShowScene"
                v-model="triggerItem.region"
                :normalizer="normalizer"
                placeholder="请选择设备区域" />
            </el-form-item>
            <el-form-item :error="isError(triggerItem.deviceType, '设备类型不能为空')">
              <el-select v-model="triggerItem.deviceType" placeholder="请选择设备类型" :disabled="!isShowScene">
                <el-option
                  v-for="item in deviceTypeOptionScene1"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(triggerItem.triggerMode, '触发方式不能为空')">
              <el-select v-model="triggerItem.triggerMode" placeholder="请选择触发方式" :disabled="!isShowScene">
                <el-option
                  v-for="(item, i) in triggerOptionScene"
                  :key="i"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <p class="drawer-title">执行器</p>
          <div v-for="(actionItem, index) in sceneForm.action" :key="`action${index}`">
            <el-form-item :error="isError(actionItem.region, '设备区域不能为空')">
              <!-- <el-cascader
                v-model="actionItem.region"
                :options="deviceRegionScene"
                :show-all-levels="false"
                :disabled="!isShowScene"
                placeholder="请选择设备区域"
                :props="propsScene"
              ></el-cascader> -->
              <treeselect
                :multiple="false"
                :flat='true'
                :options="regionOptions"
                :load-options="loadOptions"
                @select="treeEven1($event, index)"
                :disabled="!isShowScene"
                v-model="actionItem.region"
                :normalizer="normalizer1"
                placeholder="请选择设备区域" />
            </el-form-item>
            <el-form-item :error="isError(actionItem.deviceType, '设备类型不能为空')">
              <el-select v-model="actionItem.deviceType" placeholder="请选择设备类型" :disabled="!isShowScene">
                <el-option
                  v-for="item in deviceTypeOptionScene2"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(actionItem.imei, 'imei不能为空')">
              <el-select
                :disabled="!isShowScene"
                v-model="actionItem.imei"
                filterable
                remote
                reserve-keyword
                placeholder="请输入/选择imei"
                :remote-method="handleImeiScene"
                :loading="iogingScene">
                <el-option
                  v-for="item in imeiSceneData"
                  :key="item.imei"
                  :label="item.imei"
                  :value="item.imei">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :error="isError(actionItem.executeAction, '执行动作不能为空')">
              <el-select v-model="actionItem.executeAction" placeholder="请选择执行动作" :disabled="!isShowScene">
                <el-option
                  v-for="(item, i) in executeScene"
                  :key="i"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="drawerFoot" v-if="isShowScene">
        <el-button type="primary" @click="handleAddScene" :loading="dataDrawer.saving">{{ dataDrawer.saving ? '提交中' : '提交' }}</el-button>
        <el-button @click="sceneShow = false">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable.vue";
import OneGroupCheckboxs from "@/components/common/OneGroupCheckboxs";
import { LOAD_CHILDREN_OPTIONS, Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
  log
} from 'util';
export default {
  components: {
    BorderTable,
    OneGroupCheckboxs,
    Treeselect
  },
  data() {
    return {
      styleObject: {
        height: ""
      },
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableHeight: null,
      DatasLoading: false,
      isDeleting: false,
      DataList: [],
      dataDrawer: {
        show: false,
        title: "新增联动",
        checkAll: {
          value: false
        },
        form: {
          sceneName: '',
          trigger: [
            {
              deviceType: '',
              imei: '',
              type: '',
              modelType: '',
              compareType: '',
              compareValue: '',
            }
          ],
          action: [
            {
              deviceType: '',
              imei: '',
              type: '',
              modelType: '',
              compareValue: ''
            }
          ]
        },
        formRules: {
          sceneName: [{ required: true, message: "联动名称不能为空", trigger: "blur" }],
          // deviceType: [{ required: true, message: "触发器-设备类型不能为空", trigger: "blur" }],
          // imei: [{ required: true, message: "触发器-设备imei不能为空", trigger: "blur" }],
          // type: [{ required: true, message: "触发器-设备触发方式不能为空", trigger: "blur" }],
          // modelType: [{ required: true, message: "触发器-设备属性不能为空", trigger: "blur" }],
          // compareType: [{ required: true, message: "触发器-比较符号不能为空", trigger: "blur" }],
          // compareValue: [{ required: true, message: "触发器-比较值不能为空", trigger: "blur" }],
          // actionType: [{ required: true, message: "执行器-执行方式不能为空", trigger: "blur" }],
          // actionDeviceType: [{ required: true, message: "执行器-设备类型不能为空", trigger: "blur" }],
          // actionImei: [{ required: true, message: "执行器-设备imei不能为空", trigger: "blur" }],
          // actionModelType: [{ required: true, message: "执行器-设备属性不能为空", trigger: "blur" }],
          // actionCompareValue: [{ required: true, message: "执行器-比较值不能为空", trigger: "blur" }],
        },
        saving: false,
        privileges: []
      },
      isRepeatImei: false,
      // isTrigger: {
      //   imei: false,
      //   trigger: false,
      //   attr: false,
      //   comparer: false,
      //   value: false,
      // },
      // isAction: {
      //   deviceType1: false,
      //   imei1: false,
      //   attr1: false,
      //   value1: false
      // },
      selfDataMapper: {},
      queryForm: {
        orgId: -1,
        key: ''
      },
      deviceTypeOptions: [],
      isShow: true,
      isShowScene: true,
      OriginOptions: [],
      imeiLoading: false,
      imeiLoading1: false,
      triggerImeiOptions0: [],
      triggerTypeOption0: [],
      actionImeiOptions0: [],
      actionTypeOption0: [],
      imeiOptions1: [],
      triggerOption: [
        { value: '0', label: '属性触发' },
        { value: '1', label: '告警触发' }
      ],
      triggerImeiFocusIndex: '',
      actionImeiFocusIndex: '',
      typeOption1: [],
      isTBoolean0: false,
      isABoolean0: false,
      comparerOption: [
        { value: '0', label: '=' },
        { value: '1', label: '>' },
        { value: '2', label: '<' },
        { value: '3', label: '≠' }
      ],
      ExecuteActionOption: [
        { value: '0', label: '告警通知' },
        { value: '1', label: '设备执行' }
      ],
      isStart: true,
      // 场景数据
      sceneTitle: '新增场景',
      sceneShow: false,
      sceneForm: {
        sceneName: '', // 场景名称
        trigger: [{ // 触发器里边的输入框
          region: null, // 设备区域
          deviceType: '', // 设备类型
          triggerMode: '', // 触发方式
        }],
        action: [{
          region: null, // 设备区域
          deviceType: '', // 设备类型
          imei: '', // imei
          executeAction: '', // 执行动作
        }]
      },
      executeScene: [ // 执行动作
        { value: '0', label: '告警通知' },
        { value: '1', label: '下发通知' },
      ],
      deviceRegionScene: [], // 设备区域下拉数据
      deviceTypeOptionScene1: [ // 设备类型下拉数据 
      ],
      deviceTypeOptionScene2: [ // 设备类型下拉数据 
      ],
      triggerOptionScene: [ // 触发方式下拉数据
        { value: '0', label: '告警触发' }
      ],
      sceneFormRules: {
        sceneName: [{ required: true, message: "场景名称不能为空", trigger: "blur" }],
      },
      iogingScene: false,
      imeiSceneData: [],
      propsScene: {
        children: 'children',
        emitPath: false,
      },
      regionOptions:[{
        id: 0,
        label: '区域机构',
        value: 0,
        isDefaultExpanded: true,
        children: null,
        isDisabled: true
      }],
      triggerRegionName: '',
      actionRegionName: ''
    };
  },
  computed: {
    currentTreeId() {
      return this.$store.state.currentTreeId;
    },
    screenData() {
      return this.$store.state.screen;
    },
    TImeiOptions () {
      return index => {
        return this[`triggerImeiOptions${index}`]
      }
    },
    AImeiOptions () {
      return index => {
        return this[`actionImeiOptions${index}`]
      }
    },
    TTypeOptions () {
      return index => {
        return this[`triggerTypeOption${index}`]
      }
    },
    ATypeOptions () {
      return index => {
        return this[`actionTypeOption${index}`]
      }
    },
    isBoolean () {
      return index => {
        return this[`isTBoolean${index}`]
      }
    },
    isBoolean1 () {
      return index => {
        return this[`isABoolean${index}`]
      }
    },
    isError () {
      return (value, msg) => {

        return (value === '' && !this.isStart) ? msg : null
      }
    }
  },
  watch: {
    screenData() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    }
  },
  created() {
    this.makeheight();
    this.getDeviceType()
    this.handleRegion()
  },
  mounted() {
    this.queryDataList();
  },
  methods: {
    loadOptions({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let id = parentNode.id
        this.getTreeNode(id).then(res => {
          if (res.code === 200) {
            let children = res.data && res.data.map(item => {
              if (!item.isLeaf) item.children = null
              return item
            })
            parentNode.children = children
          }
          callback()
        })
      }
    },
    getTreeNode (pid = 0) {
      return new Promise((resolve, reject) => {
        this.request.get(`/front/device/region/findTreeNofenjiById?id=${pid}`).then(res => {
          resolve(res)
        }).catch(e => reject(e))
      })
    },
    treeEven (data, index) {
      console.log(data, index)
      if (data.id === 0) {
        this.sceneForm.trigger[index].region = null
        this.$message({ type: 'warning', message: '请选择有效的安装区域！' })
      }
    },
    treeEven1 (data, index) {
      console.log(data, index)
      if (data.id === 0) {
        this.sceneForm.action[index].region = null
        this.$message({ type: 'warning', message: '请选择有效的安装区域！' })
      }
    },
    normalizer (node) {
      return {
        id: node.value,
        label: node.label || this.triggerRegionName,
      };
    },
    normalizer1 (node) {
      return {
        id: node.value,
        label: node.label || this.actionRegionName,
      };
    },
    /**
     * @Description 模糊搜索imei
     * @Author      YOYO     - 2022-09-07
     * @param       {[type]} e [description]
     */
    imeiMethod (query) {
      let index = this.triggerImeiFocusIndex
      let id = this.dataDrawer.form.trigger[index].deviceType
      this.getDeviceImei(id, query, index)
    },
    /**
     * @Description 模糊搜索imei-执行动作
     * @Author      YOYO     - 2022-09-07
     * @param       {[type]} e [description]
     */
    imeiMethod1 (query) {
      let index = this.actionImeiFocusIndex
      let id = this.dataDrawer.form.action[index].deviceType
      this.getDeviceImei1(id, query, index)
    },
    /**
     * @Description 获取焦点
     * @Author      YOYO     - 2022-09-07
     * @param       {[type]} e [description]
     */
    handleFocusImei (index, key) {
      // this.triggerImeiFocusIndex = index
      this[key] = index
    },
    /**
     * @Description 失去焦点
     * @Author      YOYO     - 2022-09-07
     * @param       {[type]} e [description]
     */
    handleBlurImei (e, index) {
      let imei = this.dataDrawer.form.trigger[index].imei
      this.request.get(`/front/linkageTrigger/isDeviceImeis?imei=${imei}`).then(res => {
        this.isRepeatImei = res.code == 500 ? imei : false
        if (res.code == 500) {
          this.$message({ type: 'error', message: `${res.msg}(${imei})` })
        }
      })
      .catch(error => {
        console.error(error);
      })
    },
    /**
     * @Description change imei
     * @Author      YOYO     - 2022-09-13
     */
    handleChangeImei (e, index) {
      this.dataDrawer.form.trigger[index].type = ''
      this.dataDrawer.form.trigger[index].modelType = ''
      this.dataDrawer.form.trigger[index].compareType = ''
      this.dataDrawer.form.trigger[index].compareValue = ''
      // if (e) {
      //   this.isTrigger.trigger = true
      // } else {
      //   this.isTrigger.trigger = false
      // }
    },
    /**
     * @Description change imei1
     * @Author      YOYO     - 2022-09-13
     */
    handleChangeImei1 (e, index) {
      this.dataDrawer.form.action[index].modelType = ''
      this.dataDrawer.form.action[index].compareValue = ''
      // if (e) {
      //   this.isAction.attr1 = true
      // } else {
      //   this.isAction.attr1 = false
      // }
    },
    search() {
      this.pagination.currentPage = 1;
      this.queryDataList();
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    // tableHeightInit() {
    //   this.tableHeight = document.body.clientHeight - 350 + "px";
    // },
    /**
     * @Description 请求数据列表
     * @Author      YOYO     -             2022-07-05
     */
    queryDataList() {
      let { currentPage, pageSize } = this.pagination
      let sceneName = this.queryForm.key
      this.DatasLoading = true;
      let defaults = {
        page: currentPage,
        pageSize,
        sceneName
        // sort: 'createTime',
        // order: 'desc'
      }
      // let params = Object.assign(defaults, this.queryForm)
      this.request.get("/front/linkageTrigger/queryLinkageScenario", defaults)
        .then(rs => {
          if (rs.code == 200) {
            this.DataList = rs.data.data || []
            this.pagination.total = rs.data.totalCount
          } else {}
          this.DatasLoading = false;
        })
        .catch(error => {
          console.error(error);
          this.DatasLoading = false;
        });
    },
    /**
     * @Description 新增联动
     * @Author      YOYO     -             2022-07-05
     */    
    handleAddClick(type, data) {
      if (type == 'add' || data.linkageMode == 0 ) {
        this.isStart = true
        this.isShow = type == 'view' ? false : true
        this.dataDrawer.show = true;
        this.dataDrawer.title = '新增联动';
        let form = {
          sceneName: '',
          trigger: [
            { deviceType: '', imei: '', type: '', modelType: '', compareType: '', compareValue: '' }
          ],
          action: [
            { type: '', deviceType: '', imei: '', modelType: '', compareValue: '' }
          ]
        }
        if (type == 'edit' || type == 'view') {
          let { sceneName,  triggers, actions, id, isEnabled } = data
          this.dataDrawer.title = type == 'edit' ? '编辑联动' : '查看联动'
          form = { sceneName,  trigger: triggers, action: actions, id, isEnabled }
          this.dataDrawer.form = form
          // 展示是获取不同触发器下的设备属性列表
          triggers.forEach(({ deviceType, type }, index) => {
            let temp = this.deviceTypeOptions.find(({ typeId }) => typeId == deviceType)
            if (temp != -1) {
              let entity = temp.typeClasName
              this.getDeviceAttr(entity, index, type)
              this.incoherent(type, index)
              this.getDeviceImei(deviceType, '', index)
            }
          })
          // 不同的执行器下的设备属性列表
          actions.forEach(({ type, deviceType }, index) => {
            if (type == 1) {
              let temp = this.deviceTypeOptions.find(({ typeId }) => typeId == deviceType)
              if (temp != -1) {
                let entity = temp.typeClasName
                this.getDeviceAttr1(entity, index)
                this.getDeviceImei1(deviceType, '', index)
              }
            }
          })
        }
        this.dataDrawer.form = form
      } else {
        this.request.post(`/front/sceneLinkage/getDeviceActuatorById?sceneId=${data.id}`).then(res => {
          if (res.code == 200) {
            this.sceneShow = true
            this.triggerRegionName = res.data.trigger.regionName
            this.actionRegionName = res.data.action.regionName
            // this.form.regionId=response.data.regionId.split(",").map(item=>item*1)
            // console.log(11, this.deviceRegionScene);
            // console.log('触发器', this.deviceTypeOptionScene1);
            // console.log('执行器', this.deviceTypeOptionScene2);
            // console.log('区域', res.data.trigger.region);
            // console.log('类型', res.data.trigger.deviceType);
            let form = {
              sceneName: res.data.sceneName,
              trigger: [
                { 
                  region: res.data.trigger.region,
                  deviceType: res.data.trigger.deviceType,
                  triggerMode: res.data.trigger.triggerMode.toString()
                }
              ],
              action: [
                { 
                  region: res.data.action.region,
                  deviceType: res.data.action.deviceType,
                  imei: res.data.action.imei,
                  executeAction: res.data.action.executeAction.toString()
                }
              ],
              id: res.data.id
            }
           this.sceneForm = form
           this.sceneTitle = type == 'edit' ? '编辑场景' : '查看场景'
            if (type == 'view') {
              this.isShowScene = false
            } else {
              this.isShowScene = true
              let form = {
                sceneName: res.data.sceneName,
                trigger: [
                  { 
                    region: res.data.trigger.region,
                    deviceType: res.data.trigger.deviceType,
                    triggerMode: res.data.trigger.triggerMode.toString(),
                    id: res.data.trigger.id,
                  }
                ],
                action: [
                  { 
                    region: res.data.action.region,
                    deviceType: res.data.action.deviceType,
                    imei: res.data.action.imei,
                    executeAction: res.data.action.executeAction.toString(),
                    id: res.data.action.id,
                  }
                ],
                id: res.data.id
              }
              this.sceneForm = form
            }
          }
        })
      }
    },
    /**
     * @Description 获取设备类型
     * @Author      YOYO     -             2022-09-08
     */
    getDeviceType () {
      this.request.get('/front/linkageTrigger/getDeviceTypeEntitys').then(res => {
        if (res.code === 200) {
          this.deviceTypeOptions = res.data || []
          this.deviceTypeOptionScene2 = res.data || []
          this.deviceTypeOptionScene1 = JSON.parse(JSON.stringify(res.data))
          this.deviceTypeOptionScene1.unshift({typeId: 999, typeName: "全部"})
          if (res.data && res.data[0]) {
            // this.isTrigger.imei = true
            // this.dataDrawer.form.trigger[0].deviceType = res.data[0].typeId
            // this.getDeviceImei(res.data[0].typeId, 0)
            // this.getDeviceAttr(res.data[0].typeClasName)
          }
        }
      })
    },
    /**
     * @Description 触发器-获取设备imei
     * @Author      YOYO     -             2022-09-08
     */
    getDeviceImei (typeId, imei, index) {
      this.imeiLoading = true
      this.request.get(`/front/linkageTrigger/getDeviceImeis`, { typeId, imei }).then(res => {
        this.imeiLoading = false
        if (res.code === 200) {
          this[`triggerImeiOptions${index}`] = res.data || []
        } else {
          this[`triggerImeiOptions${index}`] = []
        }
      })
    },
    /**
     * @Description 执行器-获取设备-imei1
     * @Author      YOYO     -             2022-09-20
     */
    getDeviceImei1 (typeId, imei, index) {
      this.imeiLoading1 = true
      this.request.get(`/front/linkageTrigger/getDeviceImeis`, { typeId, imei }).then(res => {
        this.imeiLoading1 = false
        if (res.code === 200) {
          this[`actionImeiOptions${index}`] = res.data || []
        } else {
          this[`actionImeiOptions${index}`] = []
        }
      })
    },
    /**
     * @Description 获取设备类型属性
     * @Author      YOYO     -             2022-09-08
     */
    getDeviceAttr (entity, index, type) {
      // 1：告警触发，0：设备属性触发
      let url = type == '1' ? `/front/linkageTrigger/getDeviceFieldsAlarmEntitys?entity=${entity}` : `/front/linkageTrigger/getDeviceFieldsEntitys?entity=${entity}`
      this.request.post(url).then(res => {
        if (res.code === 200) {
          this[`triggerTypeOption${index}`] = res.data || []
        }
      })
    },
    /**
     * @Description 获取设备类型属性1
     * @Author      YOYO     -             2022-09-08
     */
    getDeviceAttr1 (entity, index) {
      // this.request.post(`/front/linkageTrigger/getDeviceFieldsEntitys?entity=${entity}`).then(res => {
      this.request.post(`/front/linkageTrigger/getDeviceFieldsExeEntitys?entity=${entity}`).then(res => {
        if (res.code === 200) {
          this[`actionTypeOption${index}`] = res.data || []
        }
      })
    },
    /**
     * @Description 触发器-改变设备类型
     * @Author      YOYO     - 2022-09-16
     * @param       {[type]} e [description]
     */
    handleChangeDeviceType (e, index) {
      this.dataDrawer.form.trigger[index].imei = ''
      this.dataDrawer.form.trigger[index].type = ''
      this.dataDrawer.form.trigger[index].modelType = ''
      this.dataDrawer.form.trigger[index].compareType = ''
      this.dataDrawer.form.trigger[index].compareValue = ''
      if (e !== '') {
        let typeClasNameIndex = this.deviceTypeOptions.findIndex(({ typeId }) => typeId == e)
        let typeClasName = ''
        if (typeClasNameIndex != -1) {
          typeClasName = this.deviceTypeOptions[typeClasNameIndex].typeClasName
        }
      //   // this.isTrigger.imei = true
        this.getDeviceImei(e, '', index)
        this.getDeviceAttr(typeClasName, index)
      }
    },
    /**
     * @Description 执行器-改变设备类型
     * @Author      YOYO     - 2022-09-20
     */
    handleChangeDeviceType1 (e, index) {
      this.dataDrawer.form.action[index].imei = ''
      this.dataDrawer.form.action[index].modelType = ''
      this.dataDrawer.form.action[index].compareValue = ''
      if (e !== '') {
        let typeClasNameIndex = this.deviceTypeOptions.findIndex(({ typeId }) => typeId == e)
        let typeClasName = ''
        if (typeClasNameIndex != -1) {
          typeClasName = this.deviceTypeOptions[typeClasNameIndex].typeClasName
        }

        this.getDeviceImei1(e, '', index)
        this.getDeviceAttr1(typeClasName, index)
      }
    },
    handleChangeTrigger (e, index) {
      this.dataDrawer.form.trigger[index].modelType = ''
      this.dataDrawer.form.trigger[index].compareType = ''
      this.dataDrawer.form.trigger[index].compareValue = ''

      let deviceType = this.dataDrawer.form.trigger[index].deviceType
      let temp = this.deviceTypeOptions.find(({ typeId }) => typeId == deviceType)
      let entity = temp != -1 ? temp.typeClasName : ''

      this.getDeviceAttr(entity, index, e)
      this.incoherent(e, index)
    },
    /**
     * @Description 选择不同触发属性时级联列表表现不一致
     * @Author      YOYO     -     2022-09-26
     * @param       {string} e     [触发器-值]
     * @param       {number} index [当前触发器下标]
     */
    incoherent (e, index) {
      if (e == 1) { // 告警触发
        this.comparerOption = [{ value: '0', label: '=' }]
        this[`isTBoolean${index}`] = true
      } else { // 设备触发
        this[`isTBoolean${index}`] = false
        this.comparerOption = [
          { value: '0', label: '=' },
          { value: '1', label: '>' },
          { value: '2', label: '<' },
          { value: '3', label: '≠' }
        ]
      }
    },
    handleChangeattr (e, index) {
      this.dataDrawer.form.trigger[index].compareType = ''
      this.dataDrawer.form.trigger[index].compareValue = ''
      // let fieldType = this[`triggerTypeOption${index}`].find(({ fieldName }) => fieldName == e).fieldType
      // this[`isTBoolean${index}`] = fieldType.includes('Boolean')
    },
    handleChangeattr1 (e, index) {
      this.dataDrawer.form.action[index].compareValue = ''
      // let fieldType = this[`actionTypeOption${index}`].find(({ fieldName }) => fieldName == e).fieldType
      // this[`isABoolean${index}`] = fieldType.includes('Boolean')
      // if (e) {
      //   this.isAction.value1 = true
      // } else {
      //   this.isAction.value1 = false
      // }
    },
    handleVisible (isV, i) {
      // let options = this[`triggerTypeOption${i}`]
      // if (isV && options && options.length <= 0) {
      //   let deviceType = this.dataDrawer.form.action[i].deviceType
      //   let temp = this.deviceTypeOptions.find(({ typeId }) => typeId == deviceType)
      //   if (temp != -1) {
      //     let entity = temp.typeClasName
      //     this.getDeviceAttr(entity, i)
      //   }
      //   console.log(deviceType)
      //   console.log(temp)

      // }
    },
    handleChangecomparer (e) {
      // if (e) {
      //   this.isTrigger.value = true
      // } else {
      //   this.isTrigger.value = false
      // }
    },
    handleChangeactionType (e, index) {
      this.dataDrawer.form.action[index].deviceType = ''
      this.dataDrawer.form.action[index].imei = ''
      this.dataDrawer.form.action[index].modelType = ''
      this.dataDrawer.form.action[index].compareValue = ''
    },
    /**
     * @Description 切换列表页数
     * @Author      YOYO     -             2022-07-05
     */
    handleDataCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.queryDataList();
    },
    /**
     * @Description 切换列表分页大小
     * @Author      YOYO     -             2022-07-05
     */
    handleDataSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.queryDataList();
    },
    handleDrawerClose () {
      this.dataDrawer.show = false
    },
    // 场景表单关闭
    handleDrawerCloseScene () {
      this.sceneShow = false
      this.sceneForm = {
        sceneName: '', // 场景名称
        trigger: [{ // 触发器里边的输入框
          region: null, // 设备区域
          deviceType: '', // 设备类型
          triggerMode: '', // 触发方式
        }],
        action: [{
          region: null, // 设备区域
          deviceType: '', // 设备类型
          imei: '', // imei
          executeAction: '', // 执行动作
        }]
      }
    },
    handleAddSave () {
      this.$refs['dataDrawerForm'].validate((valid) => {
        this.isStart = false

        let { trigger, action } = this.dataDrawer.form

        let isErrTrigger = trigger.some(({ deviceType, imei, type, modelType, compareType, compareValue }) => {
          return (deviceType === '' || imei === '' || type === '' || modelType === '' || compareType === '' || compareValue === '')
        })

        let isErrAction = action.some(({ deviceType, imei, type, modelType, compareValue }) => {
          if (type == '0') { // 执行器-告警通知
            return (deviceType === '' || imei === '' || type === '')
          } else {
            return (deviceType === '' || imei === '' || type == '' || modelType === '' || compareValue === '')
          }
        })

        // if (this.isRepeatImei) {
        //   return this.$message({ type: 'warning', message: `重复的IMEI(${this.isRepeatImei})`})
        // }

        if (valid && !isErrTrigger && !isErrAction) {
          let params = this.dataDrawer.form
          // params.isEnabled = true
 
          this.dataDrawer.saving = true
          this.request.post('/front/linkageTrigger/saveorupdate', params).then(res => {
            this.dataDrawer.saving = false
            let msgText = params.id ? '编辑' : '提交'
            if (res.code === 200) {
              this.dataDrawer.show = false
              this.$message({ type: 'success', message: `${msgText}成功！`})
              this.pagination.currentPage = 1
              this.queryDataList()
            } else {
              this.$message({ type: 'error', message: `${msgText}失败！${res.msg},请重新提交`})
            }
          })
        } else {
          this.$message({ type: 'warning', message: '请按照要求填写正确信息！'})
          return false;
        }
      })
    },
    // 删除列表
    handleDeleteClick (data) {
      this.$confirm('此操作将永久删除该条信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDeleting = true
          if (data.linkageMode == 0) {
            this.request.post(`/front/linkageTrigger/deleteLinkageScenario?ids=${data.id}`).then(res => {
              this.isDeleting = false
              if (res.code === 200) {
                this.$message({ type: 'success', message: '删除成功！'})
                this.pagination.currentPage = 1
                this.queryDataList()
              } else {
                this.$message({ type: 'error', message: '删除失败！请重重试'})
              }
            })
          } else {
            this.request.post(`/front/sceneLinkage/deleteLinkageScenario?ids=${data.id}`).then(res => {
              this.isDeleting = false
              if (res.code === 200) {
                this.$message({ type: 'success', message: '删除成功！'})
                this.pagination.currentPage = 1
                this.queryDataList()
              } else {
                this.$message({ type: 'error', message: '删除失败！请重重试'})
              }
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })         
        })
    },
    handleGoClick (id) {
      this.$router.push({ name: 'sceneHistory' })
    },
    // 是否启用
    handleSwithChange (e, id) {
      this.request.get('/front/linkageTrigger/enabled', { id, isEnabled: e}).then(res => {
        if (res.code == 200) {
          this.$message({ type: 'success',  message: '操作成功！'})
        } else {
          this.$message({ type: 'error',  message: '操作失败！'})
        }
        this.queryDataList();
      })
    },
    // 新增场景
    handleAddClickScene (type, data) {
      this.sceneShow = true
      this.isStart = true
      this.isShowScene = true
      this.isShow = type == 'view' ? false : true
      if (type == 'add') {
        this.sceneTitle = '新增场景';
        this.sceneForm = {
          sceneName: '',
          trigger: [{
            region: null,
            deviceType: '',
            triggerMode: '',
          }],
          action: [{
            region: null,
            deviceType: '',
            imei: '',
            executeAction: '',
          }]
        }
        this.triggerRegionName = ''
        this.actionRegionName = ''
      }
    },
    // 获取区域结构数据
    handleRegion () {
      this.request.get('/front/sceneLinkage/getDeviceRegion').then(res => {
        if (res.code == 200) {
          let dataType = []
          res.data.forEach(item => {
            if (item.isLeaf) {
              let data = {
                value: item.value,
                label: item.label,
              }
              dataType.push(data)
            } else {
              let datas = {
                value: item.value,
                label: item.label,
                children: []
              }
              this.request.get(`/front/sceneLinkage/getDeviceRegion?id=${item.value}`).then(ref => {
                if (ref.code == 200) {
                  ref.data.forEach(type => {
                    let ss = {
                      value: type.value,
                      label: type.label,
                    }
                    datas.children.push(ss)
                  })
                }
              })
              dataType.push(datas)
            }
          })
          this.deviceRegionScene = dataType
          this.deviceRegionScene.unshift({value: "0", label: "全部"})
        }
      })
    },
    // 查询imei
    handleImeiScene (val) {
      if (val != '') {
        this.request.get(`/front/sceneLinkage/getDeviceImeis?imei=${val}&typeId=${this.sceneForm.action[0].deviceType}`).then(res => {
          if (res.code == 200) {
            let data = []
            res.data.forEach(item => {
              let type = {
                imei: item.imei,
              }
              data.push(type)
            })
            this.imeiSceneData = data
          }
        })
      } else {
        this.imeiSceneData = []
      }
    },
    // 添加场景信息
    handleAddScene () {
      this.$refs['dataDrawerScene'].validate((valid) => {
        this.isStart = false

        let { trigger, action } = this.sceneForm

        let isErrTrigger = trigger.some(({ region, deviceType, triggerMode, }) => {
          return (deviceType === ''  || triggerMode === '' || region === '' || region === null)
        })

        let isErrAction = action.some(({ region, deviceType, imei, executeAction }) => {
          return (deviceType === '' || imei === '' || region == '' || executeAction === '' || region === null)
        })

        // if (this.isRepeatImei) {
        //   return this.$message({ type: 'warning', message: `重复的IMEI(${this.isRepeatImei})`})
        // }

        if (valid && !isErrTrigger && !isErrAction) {
          // this.sceneForm.trigger[0].region = this.sceneForm.trigger[0].region.toString()
          // this.sceneForm.action[0].region = this.sceneForm.action[0].region.toString()
          let params = this.sceneForm
          // params.isEnabled = true

          this.dataDrawer.saving = true
          this.request.post('/front/sceneLinkage/saveSceneLinkage', params).then(res => {
            this.dataDrawer.saving = false
            let msgText = params.id ? '编辑' : '提交'
            if (res.code === 200) {
              this.sceneShow = false
              this.$message({ type: 'success', message: `${msgText}成功！`})
              this.pagination.currentPage = 1
              this.queryDataList()
            } else {
              this.$message({ type: 'error', message: `${msgText}失败！${res.msg},请重新提交`})
            }
          })
        } else {
          this.$message({ type: 'warning', message: '请按照要求填写正确信息！'})
          return false;
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.SceneListContainer {
  .mainContent {
    margin: 12px;
    padding: 15px 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .query {
      padding: 0 20px 20px;
      .query-right {
        float: right
      }
    }

    .tableBox {
      padding: 0 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.SceneListContainer {
  .vue-treeselect {
    width: 260px;

    .vue-treeselect__control {
      div {
        line-height: 32px;
        height: 32px;
      }
    }
  }
  .drawerWrap {
    border: 1px solid transparent;
    .drawerBody {
      margin-top: 20px;
    }
    .el-form .el-input {
      width: 162px;
    }
    .drawer-title {
      font-size: 16px;
      position: relative;
      margin-bottom: 10px;
      &::before {
        position: absolute;
        content: '';
        height: 12px;
        border-left: 2px solid #2177E6;
        top: 5px;
        left: -10px;
      }
    }
  }
  .drawerWrap .el-form .el-form-item__content .input-name{
    width: 600px;
  }
  // .drawerWrap .el-form .el-form-item__content .el-textarea{
  //   width: 600px;
  // }
  // .drawerWrap .el-form .el-form-item__content .el-input{
  //   width: 600px;
  // }
  .mainContent {
    .query {
      .el-input {
        width: 200px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }

  }

  .formBox {
    .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: middle;
      .content-panel {
        line-height: 40px;

        &>.el-checkbox {
          line-height: 50px;
        }
      }

      .privilege-form-item {
        padding: 0 10px;
      }
    }
    .name-form {
      display: block;
    }
  }

  .contentShowArea {

    .el-table__fixed-right {
      &::before {
        display: none;
      }

      .el-table__fixed-body-wrapper {
        tbody {
          tr {
            td {
              // border: none;
              // padding: 9px 0;

              .cell {
                text-align: center;

                .editBtn {
                  color: #28c6a2;
                }

                .delBtn {
                  color: #dd3071;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
